import { render, staticRenderFns } from "./ObjectAuthorizationForm.vue?vue&type=template&id=5116e1c2&"
import script from "./ObjectAuthorizationForm.vue?vue&type=script&lang=ts&"
export * from "./ObjectAuthorizationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports